export const EVENT = {
  name: "Pak Fest 2026",
  tagline: "Where Winnipeg Meets Pakistan",
  dateLabel: "Friday, August 14, 2026",
  timeLabel: "5:00 PM – 9:00 PM",
  venue: "Bridgewater Lakes Park",
  address: "133 Bridge Lake Dr, Winnipeg, MB",
  host: "Canada Pakistan Trade and Culture Association (CPTCA)",
  // Aug 14, 2026, 5:00 PM Central Time (CDT = UTC-5)
  target: new Date("2026-08-14T17:00:00-05:00"),
  mapsEmbed:
    "https://www.google.com/maps?q=Bridgewater+Lakes+Park,+133+Bridge+Lake+Dr,+Winnipeg,+MB&output=embed",
  directions:
    "https://www.google.com/maps/dir/?api=1&destination=Bridgewater+Lakes+Park,+133+Bridge+Lake+Dr,+Winnipeg,+MB",
};

export const FEATURES = [
  {
    key: "food",
    title: "Street Food & Vendors",
    icon: "utensils",
    blurb:
      "A feast from Karachi to Gilgit Baltistan — sizzling grills, chaat, biryani, sweets and chai across the park.",
    img: "https://images.unsplash.com/photo-1572015837827-01671d41e102?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwxfHxwYWtpc3RhbiUyMHN0cmVldCUyMGZvb2QlMjB2ZW5kb3J8ZW58MHx8fHwxNzgzMTI5MTc5fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    key: "performances",
    title: "Live Cultural Performances",
    icon: "mic",
    blurb:
      "Live music, dance and cultural performances celebrating Pakistani heritage throughout the evening.",
    img: "https://customer-assets.emergentagent.com/job_cptca-festival/artifacts/ssk7wi4t_IMG_0657.jpeg",
  },
  {
    key: "kids",
    title: "Bouncy Castles & Kids Zone",
    icon: "baby",
    blurb:
      "Family-friendly attractions and bouncy castles keeping the little ones smiling all night long.",
    img: "https://images.unsplash.com/photo-1740033135773-bf7c886ae45a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwxfHxraWRzJTIwYm91bmN5JTIwY2FzdGxlJTIwZmVzdGl2YWx8ZW58MHx8fHwxNzgzMTI5MTc5fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    key: "flag",
    title: "Independence Day Flag Raising",
    icon: "flag",
    blurb:
      "A formal Pakistan Independence Day flag-raising ceremony — a centerpiece moment tying the festival to August 14.",
    img: "https://images.unsplash.com/photo-1577655791634-40e1da438fd0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHw0fHxwYWtpc3RhbiUyMGZsYWclMjBjZWxlYnJhdGlvbnxlbnwwfHx8fDE3ODMxMjkxNzl8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    key: "inaam",
    title: "Lucky Draws — Inaam Ghar",
    icon: "gift",
    blurb:
      "\"Inaam Ghar\" means House of Prizes. Raffle-style draws run throughout the evening — entries may tie to vendor purchases or registration. Details on how to enter coming soon.",
    img: "https://images.unsplash.com/photo-1715520928476-cd350276d96e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwxfHxyYWZmbGUlMjBsdWNreSUyMGRyYXclMjB0aWNrZXR8ZW58MHx8fHwxNzgzMTI5MTkyfDA&ixlib=rb-4.1.0&q=85",
  },
  {
    key: "artisans",
    title: "Artisan & Cultural Vendors",
    icon: "shopping-bag",
    blurb:
      "Handmade crafts, clothing, jewelry and cultural goods from local artisans and community vendors.",
    img: "https://images.unsplash.com/photo-1760726744447-97f9d190a701?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwzfHxhcnRpc2FuJTIwY3JhZnRzJTIwdmVuZG9yJTIwc3RhbGx8ZW58MHx8fHwxNzgzMTI5MTc5fDA&ixlib=rb-4.1.0&q=85",
  },
];

export const SPONSOR_TIERS = [
  { key: "Title", label: "Title Sponsor" },
  { key: "Champion", label: "Champion" },
  { key: "Community", label: "Community" },
];

export const VENDOR_CATEGORIES = [
  { key: "food", label: "Licensed Food Vendor", price: 150 },
  { key: "baked", label: "Home-Based Baked Goods (Not Cooked)", price: 90 },
  { key: "retail", label: "Retail & Boutique Vendor", price: 85 },
  { key: "services", label: "Professional & Community Services", price: 150 },
  { key: "government", label: "Government & Community Outreach Booth", price: 350 },
];

export const ADDONS = [
  { key: "power", label: "Power Outlet Access", price: 10 },
  { key: "table", label: "Table & Chair Rental", price: 10 },
];

export const MB_FOOD_POLICY_URL = "https://www.gov.mb.ca/health/publichealth/environmentalhealth/protection/docs/tempfood.pdf";
export const MB_FOOD_APPLICATION_URL = "https://www.gov.mb.ca/health/publichealth/environmentalhealth/protection/docs/tempfood-application.pdf";
export const SPONSORSHIP_PACKAGE_URL = "https://customer-assets-gfyr7b9c.emergentagent.net/job_cptca-festival/artifacts/2bg3hvpe_Pak%20fest%20Sponsorship%20package%20.pdf";

export const VOLUNTEER_AREAS = [
  "Setup/Teardown",
  "Registration Desk",
  "Hospitality",
  "Kids Zone",
  "Vendor Support",
  "Stage/AV",
];

export const TALENT_OPTIONS = [
  "Singing",
  "Cultural Dance",
  "Musical Instrument / Live Music",
  "Kids National Anthem Choir",
  "Hosting / MC",
  "Event Planning",
  "Poetry / Spoken Word",
  "Other",
];
